<template>
  <modal :show="show" header-classes="justify-content-center" @close="handleClose()">
    <h4 slot="header" class="title" v-if="!pageCount">
      When was this bible study completed?
    </h4>
    <h4 slot="header" class="title" v-if="pageCount">
      Are you sure?
    </h4>
    <div class="modal-body">
      <div class="modal-split" v-if="!pageCount">
        <p style="color:red; font-size:16px; margin-top:0px">
          *No further bible study attendances will be generated once you submit an end date below.
          This bible study will not be able to be reactivated!
        </p>

        <datepicker
          class="datepicker"
          placeholder="Select Date"
          v-model="endDate"
          :disabled-dates="invalidDates"
        />
        <div>
          <p
            v-show="endDateError"
            :class="{
              validationErrorText: endDateError
            }"
          >
            {{ endDateError }}
          </p>
        </div>
      </div>
      <!-- This is the second warning that appears after the user has selected an end date.
      pageCount is a variable that is changed when "Continue" is pressed the first time and
      reset if "Cancel" is pressed. -->
      <div class="modal-split" v-if="pageCount">
        <h4 style="color:red; margin-top:0px; margin-bottom:0px">
          Are you sure you want to end this bible study? <br> <br>
          It <strong> CANNOT be reopened or edited </strong>once you make this change.
        </h4>
      </div>
    </div>
    <template slot="footer">
      <p-button @click="handleClose()">
        Cancel
      </p-button>
      <p-button
        type="danger"
        v-if="!pageCount"
        @click="validateInput()"
      >
        Continue
      </p-button>
      <p-button
        type="danger"
        style="marginright:5%"
        v-if="pageCount"
        @click="handleSave()"
      >
        Yes, I'm sure. End this bible study.
      </p-button>
    </template>
  </modal>
</template>

<script>
import {
    mapState, mapGetters, vuex
} from 'vuex';
import Datepicker from 'vuejs-datepicker';
import modal from '../UIComponents/Modal';

export default {
    name: 'CompleteBSModal',
    components: {
        modal,
        Datepicker
    },
    data() {
        return {
            namespace: 'BibleStudies',
            endDate: null,
            invalidDates: {
                from: new Date(Date.now()),
                to: new Date(this.bibleStudy.start_date)
            },
            endDateError: null,
            pageCount: 0,
            modals: {
                confirmcompleteBSOpen: false
            }
        };
    },
    props: {
        show: Boolean,
        bibleStudy: Object,
    },
    computed: {
        ...mapState({
            error: (state) => state.BibleStudies.error,
        }),
    },
    methods: {
        validateInput() {
            switch (this.endDate == null) {
            case true:
                this.endDateError = 'Please select an end date.';
                break;
            default:
                this.endDateError = null;
            }
            switch (!this.endDateError) {
            case true:
                this.changePage();
                break;
            default:
                break;
            }
        },
        changePage() { // Called after Continue is pressed the first time, used to toggle extra warning
            this.pageCount = 1;
        },
        handleSave() {
            const bibleStudyData = {
                end_date: this.transformJSDateForPayload(this.endDate),
                id: this.bibleStudy.id,
            };
            this.$store.dispatch(`${this.namespace}/updateBibleStudy`, {
                bible_study_data: bibleStudyData
            }).then((id) => {
                this.$router.push({ name: 'BibleStudiesView', params: { id } });
            });
            this.endDate = null;
            this.handleClose();
        },
        handleClose() {
            this.endDate = null;
            this.endDateError = null;
            this.pageCount = 0;
            this.$emit('close');
        },
    },
};
</script>
<style scoped>
.btn.btn-danger {
  margin: 2%;
}
</style>
